import Vue from 'vue';

import { AAutocomplete } from 'core_a-autocomplete';
import { ADefaultList } from 'core_a-default-list';
import { ADataTable } from 'core_a-data-table';
import { ACheckbox } from 'core_a-checkbox';
import { ATooltip } from 'core_a-tooltip';
import { ADialog } from 'core_a-dialog';
import { AToast } from 'core_a-toast';
import { AToastNotification } from 'core_a-toast-notification';
import { AInput } from 'core_a-input';
import { ATabs } from 'core_a-tabs';
import { ABtn } from 'core_a-btn';


const components = {
  ABtn,
  ATabs,
  AToast,
  AToastNotification,
  AInput,
  ADialog,
  ATooltip,
  ACheckbox,
  ADataTable,
  ADefaultList,
  AAutocomplete
};


export const maisAComponentsRegister = () => {
  Object.entries(components).forEach(([name, component]) => {
    Vue.component(name, component);
  });
};
